import React from "react";
import { useNavigate } from "react-router-dom";

// Segmented Huur/Koop switch. `active` = "huur" | "koop".
export const HuurKoopSwitch = ({ active = "huur", className = "" }) => {
  const navigate = useNavigate();
  const base = "flex-1 rounded-full px-5 py-2 text-sm font-bold transition-colors text-center";
  return (
    <div
      data-testid="huur-koop-switch"
      className={`inline-flex w-full max-w-xs items-center gap-1 rounded-full border border-border bg-white p-1 shadow-sm ${className}`}
    >
      <button
        data-testid="switch-huur"
        onClick={() => navigate("/woningen")}
        className={`${base} ${active === "huur" ? "bg-brandblue text-white" : "text-slate-600 hover:text-navy"}`}
      >
        Te huur
      </button>
      <button
        data-testid="switch-koop"
        onClick={() => navigate("/koopwoningen")}
        className={`${base} ${active === "koop" ? "bg-brandblue text-white" : "text-slate-600 hover:text-navy"}`}
      >
        Te koop
      </button>
    </div>
  );
};
